import * as React from 'react'

import { Box, CheckBox, Table, Text } from '@factorialco/deprecated-design-system'
import isEqual from 'lodash/isEqual'

import { observer } from 'mobx-react'

import type FiltersForm from 'modules/core/lib/forms/Filters'
import i18n from 'modules/core/lib/i18n'

import SortableHeader from '../../../_common/_SortableHeader'

interface Props {
  checkable?: boolean
  selectable?: Array<number | null>
  onSelectAll?: () => void
  selected?: Set<number | Date>
  filtersForm: FiltersForm
}

interface CheckProps {
  selectable?: Array<number | null>
  onSelectAll?: () => void
  selected?: Set<number | Date>
}

const TableCheckBox = ({ onSelectAll, selected, selectable }: CheckProps) => {
  return (
    <CheckBox
      label={i18n.t('common.select_all')}
      checked={
        !!selected && selected.size !== 0 && isEqual([...selected].sort(), selectable?.sort())
      }
      onClick={onSelectAll}
    />
  )
}

const Header = ({ selected, checkable, selectable, filtersForm, onSelectAll }: Props) => {
  return (
    <Table.Head>
      <Table.Row>
        <Table.HeadCell wide>
          <Box flexDirection="row" gap="s12" alignItems="center">
            {checkable && selected && (
              <Box width="s40">
                <TableCheckBox
                  onSelectAll={onSelectAll}
                  selected={selected}
                  selectable={selectable}
                />
              </Box>
            )}
            <Text size="200" color="grey800" weight="semibold">
              {i18n.t('payroll_bundle.results_payments.payments.table.header.employee')}
            </Text>
          </Box>
        </Table.HeadCell>
        <SortableHeader filtersForm={filtersForm} attribute="base_salary" width={200}>
          <Text size="200" color="grey800" weight="semibold">
            {i18n.t('payroll_bundle.results_payments.payments.table.header.amount')}
          </Text>
        </SortableHeader>
        <SortableHeader filtersForm={filtersForm} attribute="gross_salary">
          <Text size="200" color="grey800" weight="semibold">
            {i18n.t('payroll_bundle.results_payments.payments.table.header.bank_account')}
          </Text>
        </SortableHeader>
      </Table.Row>
    </Table.Head>
  )
}

export default observer(Header)
